/**
 * UrbanEntityAttributesView — Vista de attributes JSONB
 *
 * @remarks
 * Muestra el contenido del campo `attributes` de una UrbanEntity como una
 * tabla clave/valor. No permite edición (Fase 2A es solo lectura).
 *
 * @module urban-inventory/components
 */

interface UrbanEntityAttributesViewProps {
  attributes: Record<string, unknown>;
}

export function UrbanEntityAttributesView({ attributes }: UrbanEntityAttributesViewProps): JSX.Element {
  const entries = Object.entries(attributes);

  if (entries.length === 0) {
    return (
      <p style={{ margin: 0, fontSize: '12px', color: 'var(--color-text-muted, #94a3b8)', fontStyle: 'italic' }}>
        Sin atributos adicionales
      </p>
    );
  }

  return (
    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
      <tbody>
        {entries.map(([key, value]) => (
          <tr key={key} style={{ borderBottom: '1px solid var(--color-border-subtle, #f1f5f9)' }}>
            <td
              style={{
                padding: '4px 8px 4px 0',
                color: 'var(--color-text-secondary, #64748b)',
                verticalAlign: 'top',
                whiteSpace: 'nowrap',
                fontWeight: 500,
                minWidth: '80px',
              }}
            >
              {key}
            </td>
            <td
              style={{
                padding: '4px 0',
                color: 'var(--color-text, #1e293b)',
                wordBreak: 'break-all',
              }}
            >
              {formatAttributeValue(value)}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function formatAttributeValue(value: unknown): string {
  if (value === null || value === undefined) return '—';
  if (typeof value === 'boolean') return value ? 'Sí' : 'No';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
}
